import { call, put } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import Axios from "../../utils/axios";
import {
  createAccountDone,
  createAccountError,
  loginDone,
  cleanNextUrl
} from "../../state/user/actions";
import { ACCOUNT_LOGIN, ACCOUNT_CREATE_EDIT } from "../../state/user/constants";
import { setUserId, showErrorSnackbar } from "../../utils/util";
import {
  ACCOUNT_CREATED_MESSAGE,
  ACCOUNT_CREATE_ERROR_MESSAGE,
  CREDENTIALS_ERROR_MESSAGE,
  ACCOUNT,
  ACCOUNT_INFORMATION
} from "../../constants";

function* createAccount({ payload }) {
  try {
    const {
      email,
      firstName,
      lastName,
      password,
      clientId,
      history,
      location,
      nextUrl,
      shortName
    } = payload;
    const result = yield call(Axios.core.post, ACCOUNT_CREATE_EDIT, {
      clientId,
      email,
      firstName,
      lastName,
      password,
      isClientUser: true,
      isEdit: false,
      updatePassword: false
    });
    yield put(createAccountDone());

    if (result?.data) {
      const { success, userId } = result.data;
      if (success) {
        toastr.clean();
        toastr.success("", ACCOUNT_CREATED_MESSAGE, {
          timeOut: 5000
        });

        const resultLogin = yield call(Axios.core.post, ACCOUNT_LOGIN, {
          clientId,
          password,
          email
        });

        if (resultLogin?.data) {
          const { success: loginSuccess, token } = resultLogin.data;
          if (loginSuccess) {
            // Store Auth token
            yield call(Axios.setAuthToken, token.idToken);
            // Store user ID
            yield call(setUserId, userId);

            yield put(
              loginDone({ id: userId, username: email, firstName, lastName })
            );

            if (nextUrl) {
              yield call(history.push, nextUrl);
              yield put(cleanNextUrl());
            } else {
              // Redirect to account page
              yield call(
                history.push,
                `/${shortName}/${ACCOUNT}/${ACCOUNT_INFORMATION}${location.search}`
              );
            }
          } else {
            showErrorSnackbar(CREDENTIALS_ERROR_MESSAGE, {
              removeOnHover: false
            });
          }
        }
      } else {
        showErrorSnackbar(ACCOUNT_CREATE_ERROR_MESSAGE, {
          removeOnHover: false
        });
      }
    }
  } catch (e) {
    const errorMessage = JSON.parse(e.request.response).message;
    showErrorSnackbar(errorMessage, {
      removeOnHover: false
    });
    yield put(createAccountError(e));
  }
}

export default createAccount;
